<div class="circle-graph"
     data--circle--graph
     [ngClass]="{'default-color': defaultColor}"
     [class.gt-red]="progress <= 33"
     [class.gt-yellow]="progress > 33 && progress <= 50"
     [class.gt-after-50]="progress > 50"
     [class.gt-yellow-after-50]="progress > 50 && progress <= 66"
     [class.gt-green-after-50]="progress > 66"
     [attr.data-percent]="progress"
     style='--circle-graph-size:{{graphSize}}rem;'>
    <div class="circle-graph-progress">
        <div class="circle-graph-progress-fill"
             [style.transform]="'rotate(' + ((360 * this.progress) / 100) + 'deg)'">
        </div>
    </div>
    <div class="circle-graph__centered-section">
        <p *ngIf="contentInCenterFirstElement" class="circle-graph__centered-section__first-element">{{contentInCenterFirstElement}}</p>
        <p *ngIf="contentInCenterSecondElement" class="circle-graph__centered-section__second-element">{{contentInCenterSecondElement}}</p>
    </div>
</div>
